export default __webpack_public_path__ + "static/media/viya.a69b92b4.png";